<template>
  <div class="bg-white" style="padding: 15px">
    <el-row>
      <el-col :span="12" :offset="12">
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>
            <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input>
          </el-form-item>
          <el-button size="small" type="primary" @click="fetch(1)"
            >Search</el-button
          >
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="list.data"
      v-loading="isLoading"
      empty-text="No records found."
    >
      <el-table-column label="Actions" width="100">
        <template slot-scope="scope">
          <router-link
            v-if="scope.row.status"
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'user_info', params: { id: scope.row.username } }"
            title="View user information"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
          <el-button
            v-show="!scope.row.status"
            type="warning"
            icon="el-icon-s-opportunity"
            title="Reinstate user"
            circle
            size="small"
            @click="reinstate(scope.row)"
          ></el-button>

          <!-- <el-button size="small" type="primary"  icon="el-icon-folder-opened" circle></el-button> -->
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="itemDelete(scope.row.id)"
            circle
            v-if="user.isRole(1) && scope.row.status == true"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="Lastname" width="150" prop="last_name" />
      <el-table-column label="Firstname" width="150" prop="first_name" />
      <el-table-column label="Username" prop="username" />
      <el-table-column label="Email" prop="email" />
      <el-table-column label="User Type" prop="user_type_name" />
    </el-table>
    <el-pagination
      v-show="!isLoading"
      class="pt-1"
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    >
    </el-pagination>
  </div>
</template>

<script>
import User from "@/models/User";
export default {
  name: "users_list",
  computed: {
    list() {
      return this.$store.getters["user/list"];
    },
    user() {
      return this.$store.getters["auth/user"];
    },
  },
  data() {
    return {
      isLoading: false,
      pager: {
        limit: 25,
        search: ""
      }
    };
  },
  methods: {
    itemDelete(id) {
      this.$confirm("Are you sure you want to delete this user?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          User.reinstate({ id: id, status: 0 }).then(resp => {
            if (resp.code == 200) {
              this.fetch(1);
            }
          });
        }).catch(() => {});
    },
    fetch(page) {
      this.pager.page = page;

      this.isLoading = true;
      var params = { ...this.pager };
      // if (!this.pager.search) delete params.search;
      this.$store.dispatch("user/getList", params).then(() => {
        this.isLoading = false;
      });
    },
    reinstate(user) {
      this.isLoading = true;
      User.reinstate({ id: user.id, status: 1 }).then(resp => {
        if (resp.code == 200) {
          this.fetch(1);
        }
      });
    }
  },
  mounted() {
    this.fetch(1);
  }
};
</script>

<style lang="css" scoped></style>
